import React, {useCallback, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';
import {
	serviceURL,
	ToastMessageVariants,
	smartScreenRoutes,
	canvasUrlParams
} from '../../../../../../../util/uiconstants';
import {currentResource, labels} from '../../../../../../../util/utils';
import Env from '../../../../../../../util/env';
import {setIsModalOpen} from '../../../../../../../actions/setismodalopen';
import {createCanvasFormSnapshot} from '../../../../../../../actions/Task/signoffsaction';
import {setFormV2ToasterVisibility} from '../../../../../../../actions/toastactions';
import {submitIndependenceTemplate} from '../../../../../../../actions/FormData/formdataactions';
import {getLastSectionByDocumentId} from '../../../../../../../selectors/Ares/selectors';
import {getValidationsForDocumentId} from '../../../../../../../selectors/Forms/canvasFormSelectors';
import {useUserPreferences} from '../../../../../../../util/customHooks';
import {useAresUrlParameters} from '../../../../../../../util/Ares/customHooks';
import Button from '../../../../../../Common/BaseComponentWrappers/MotifButton';
import LoadingIndicator from '../../../../../../Common/LoadingIndicator/LoadingIndicator';

export default function IndependenceTemplateFooter({engagementId, document}) {
	const dispatch = useDispatch();
	const toastMessagesFeatureName = 'GuidedWorkflow';
	const genericErrorCode = '7026';

	const {sectionId} = useAresUrlParameters();

	const documentId = document?.id;

	const userPreferences = useUserPreferences();
	const validations = useSelector((store) => getValidationsForDocumentId(store, documentId));
	const lastFormSection = useSelector((store) => getLastSectionByDocumentId(store, documentId));

	const isLastSection = lastFormSection?.id === sectionId;

	const [isLoading, setIsLoading] = useState(false);

	const permissions = userPreferences?.permissions;

	let hasPermission = permissions?.canUpdateEngagementContent;

	/*
    // Do I need this?
    if (
		hasPermission &&
		validations?.length > 0
	) {
		hasPermission = validations.some(
			(validation) => validation.validationTypeId === validationTypes.IndependenceTemplateDifferentFromIndividual
		);
	}
    */

	const onSubmitIndependenceClick = useCallback(async () => {
		dispatch(setIsModalOpen(false));

		// Submit independence validations
		if (!hasPermission) {
			dispatch(
				setFormV2ToasterVisibility(
					true,
					ToastMessageVariants.Error,
					labels.insufficientRightsForIndependenceSubmission,
					toastMessagesFeatureName
				)
			);
			return;
		}

		setIsLoading(true);
		props.setIsLoading(true);

		await dispatch(submitIndependenceTemplate(engagementId, documentId)).catch(() => {
			dispatch(
				setFormV2ToasterVisibility(
					true,
					ToastMessageVariants.Error,
					currentResource.Errors[genericErrorCode],
					toastMessagesFeatureName
				)
			);
			setIsLoading(false);
			props.setIsLoading(false);
		});

		// Snapshot call:
		let snapshotRequestURL = `${Env.getBaseURL(serviceURL, engagementId)}Forms/${documentId}/Snapshots`;

		await dispatch(createCanvasFormSnapshot(snapshotRequestURL, {ApprovalId: 0}));

		// Redirect to independence smartscreen
		setIsLoading(false);
		props.setIsLoading(false);

		const independenceSummaryUrl = `${Env.getURL('hercules_web')}${smartScreenRoutes.independence}?${
			canvasUrlParams.engagementid
		}=${engagementId}&${canvasUrlParams.documentId}=${documentId}`;

		window.location.href = independenceSummaryUrl;
	}, [dispatch, engagementId, documentId, hasPermission, validations]);

	const showSubmitButton = isLastSection;

	return (
		<StyledIndependenceTemplateFooter className="StyledIndependenceTemplateFooter">
			{isLoading && <LoadingIndicator show fullscreen styleName="LoadingIndicator StyledIndependenceTemplateFooter" />}
			{showSubmitButton && (
				<Button
					className="submit-independence-btn"
					onClick={onSubmitIndependenceClick}
					variant="primary"
					showLabel
					buttonLabel={labels.submitTemplate}
					size="large"
				/>
			)}
		</StyledIndependenceTemplateFooter>
	);
}

const StyledIndependenceTemplateFooter = styled.section`
	display: flex;
	flex-direction: row;
	align-items: center;
	.submit-independence-btn {
	}
`;
